import Box from "@mui/material/Box";
import {styled} from "@mui/material";

export const OverlayContainer = styled(Box)({
    position: 'relative',
})

export const OverlayBox = styled(Box)({
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top:0,
})

export const FadeInOverlayBox = styled(OverlayBox)({
    opacity: 0,
    transition: 'opacity 0.2s',
    '&:hover': {
        opacity: 1
    }
})